import React from "react";
import {getSyncEngineVersion} from "../../../../common/helpers/syncEngine";
import SubscriptionV1 from "../../LogV1/subscription";
import SubscriptionV2 from "../../LogV2/subscription";

const Subscription: React.FC = () => {
    return getSyncEngineVersion() === 'v2' ? <SubscriptionV2 /> : <SubscriptionV1 />;
};

export default Subscription;
